import {forwardRef} from "react";
import {LayoutHeader} from "@tinct/web-layout";
import {UpdateBusinessProfileForm} from "../../../forms/update-business-profile-form";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {useFunnel} from "@tinct/web-funnel";

export const Step3CompanyProfile = forwardRef<HTMLFormElement, object>((_, ref) => {
  console.log("Rendering Step3CompanyProfile");
  const workspaceId = useGetCurrentWorkspaceId();
  const { navigateToNextStep } = useFunnel();

  return (
    <div className="container max-w-4xl mx-auto gap-8 flex flex-col py-8">
      <LayoutHeader
        pageTitle="Brand Guidelines"
        pageDescription="Company Profile"
        />
      <UpdateBusinessProfileForm ref={ref} organizationId={workspaceId} onSuccess={navigateToNextStep} hideFooter />
    </div>
  );
});

Step3CompanyProfile.displayName = 'Step3CompanyProfile';
